// extracted by mini-css-extract-plugin
module.exports = {"code":"_404Page_code_3pHqM","title":"_404Page_title_1rPjE"};